import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmsLoginComponent } from './sms-login.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    SmsLoginComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class SmsLoginModule { }
